import axios from "axios";
import Cookie from "universal-cookie";
//import { useDispatch } from "react-redux";
//import { setUser, clearUser } from "../redux/userSlice"; // Update with actual path
import {API_BASE_URL, API_FORGOT_URL, API_GATEWAY_URL, API_LOGIN_URL, API_RESET_URL} from "../config/constants";
import { IRegister } from "../components/Auth/IRegister";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import CookieUtil from "../utils/cookieUtil";

const cookie = new Cookie();

const useAuth = () => {
  const eventData:any = useSelector((state: RootState) => state.eventData);
 // const dispatch = useDispatch();

  /**
   * Sign up a new user
   * @param {Object} params - Signup data
   * @param {string} params.email - User email
   * @param {string} params.password - User password
   * @param {string} params.username - User username
   * @returns {Promise<any>} Response data from the server
   */
  const signUp = async (formData:any): Promise<any> => {
    console.log(formData)
    return axios(API_GATEWAY_URL + 'api/event-user', {
        method: 'POST',
        data: JSON.stringify(formData),
        headers: {
            'Content-Type': 'application/json',
        }
      })
    };

  /**
   * Login a user
   * @param {Object} params - Login data
   * @param {string} params.email - User email
   * @param {string} params.password - User password
   * @returns {Promise<any>} Response data from the server
   */
  const login = async ({
    email,
    password,
    enroll = true, // Default value is false
    s_id = eventData._id // Default value
  }: {
    email: string;
    password: string;
    enroll?: boolean; // Optional parameter
    s_id?: string; // Optional parameter
  }): Promise<any> => {
    try {
      const response = await axios.post(`${API_LOGIN_URL}`, {
        email,
        password,
        enroll, // Include the enroll parameter
        s_id,   // Include the s_id parameter
      });

      const { token, user } = response.data;

      // Store token in cookies
      cookie.set("session_token", token, { path: "/", secure: true, httpOnly: false });

      // Dispatch to Redux store
      // dispatch(
      //   setUser({
      //     email: user.email,
      //     username: user.username,
      //   })
      // );

      return response;
    } catch (error: any) {
      console.error("Login failed:", error.response?.data || error.message);
      throw error;
    }
  };

  /**
   * Get the current user from cookies
   * @returns {Promise<any>} User data
   */
  const getUser = async (): Promise<any> => {
    try {
     
    } catch (error: any) {
      console.error("Failed to get user:", error.response?.data || error.message);
      throw error;
    }
  };

  /**
   * Logout the user
   */
  const logout = () => {
    cookie.remove("session_token", { path: "/" });
   // dispatch(clearUser());
    console.log("User logged out.");
  };
  

  /**
   * Forgot Password
   * Sends a password recovery email to the user
   * @param {string} email - User's email
   * @returns {Promise<any>} Response data from the user
   */
  const forgotPassword=async(email:string):Promise<any>=>{
    try {
      const response = await axios.post(`${API_FORGOT_URL}`,{
        email,
      })
      console.log("Password recovery email sent:",response.data)
      return response.data.data.message|| "Reset link sent successfully.";
    } catch (error:any) {
      console.error("Forgot password request failed:", error.response?.data||error.message)
      throw error
    }
  }

   /**
   * Reset Password
   * Resets the user's password using a token and new password
   * @param {string} token - The reset token
   * @param {string} newPassword - The new password
   * @returns {Promise<any>} Response data from the server
   */
    const resetPassword = async ( newPassword: string,email_token:any): Promise<any> => {
    //const url = window.location.href;
    //const genToken=url.split('/').pop()
    try {
      const response = await axios.post(`${API_RESET_URL}`, {
        token:email_token,
        newPassword,
      });

      console.log("Password reset successful:", response.data);
      return response.data.data.message || "Password reset successfully.";
    } catch (error: any) {
      console.error("Password reset failed:", error.response?.data.data.message || error.message);
      throw error;
    }
  };

  const saveUserdataInCookies= async (userdata:any) =>{
    try {
        console.log("userdata=====>",userdata)
        if (userdata.profile_picture === null) {
          var defaultPic = {
              id: 'default_user',
              file_name: 'user_profile_image.jpg',
          }
          userdata.profile_picture = defaultPic
    }

    var data = {
          _id: userdata._id,
          first_name: userdata.first_name,
          last_name: userdata.last_name,
          phone: userdata.Phone,
          email: userdata.email,
          gender: userdata.gender,
          profile_picture: userdata.profile_picture,
          is_paid: userdata.is_paid,
          user_type: userdata.user_type,
          allow_notification: userdata.allow_notification,
          company_name: "",
          job_title: "",
          event_id: userdata.event_id,
          is_private: userdata.is_private,
          user_biography: "",
          facebook_profile: "",
          twitter_profile: "",
          linkedin_profile: "",
          portfolio_link: ""
    }

    CookieUtil.setCookie("user_info", JSON.stringify(data))
    localStorage.setItem('first_name', userdata.first_name)
    localStorage.setItem('last_name', userdata.last_name)
    return true;
    } catch (error) {
      console.log("sav data error:  ",error)
    }
    
}

  return { signUp, login, logout, getUser,forgotPassword,resetPassword,saveUserdataInCookies};
};

export default useAuth;
